import React, { useState } from 'react';
import { Button, Typography, Box } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const styles = require('./styles.pcss');

interface EmailPreviewProps {
  username: string;
  password: string;
  onConfirm: Function;
}

const EmailPreview: React.FC<EmailPreviewProps> = ({
  username,
  password,
  onConfirm,
}) => {
  const [copySuccess, setCopySuccess] = useState<boolean>(false);
  const templateText = `
Hello,

Your HRIS integration account has been created.

Username: ${username}
Password: ${password}

Please use these credentials to log in and complete your setup.

Best regards,
The TravelBank Team
  `.trim();
  const onCopy = () => {
    try {
      navigator.clipboard.writeText(templateText);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 1000);
    } catch (e) {
      setCopySuccess(false);
    }
  };
  return (
    <Box className={styles.emailPreviewContainer}>
      <Typography
        className={styles.supportText}
        variant="body2"
        sx={{ mb: 2 }}
      >
        Copy the template below and send as an encrypted email via your mailer
      </Typography>
      <Box
        display="flex"
        alignItems="center"
        mb={2}
      >
        <Button
          variant="outlined"
          size="small"
          startIcon={<ContentCopyIcon />}
          onClick={onCopy}
          className={styles.copyButton}
        >
          {copySuccess ? 'Copied!' : 'Copy'}
        </Button>
      </Box>
      <Box className={styles.emailPreviewBox}>
        <Typography
          variant="body1"
          paragraph
        >
          Hello,
        </Typography>
        <Typography
          variant="body1"
          paragraph
        >
          Your HRIS integration account has been created.
        </Typography>
        <Typography
          variant="body1"
          paragraph
        >
          <strong>Username:</strong> {username}
          <br />
          <strong>Password:</strong> {password}
        </Typography>
        <Typography
          variant="body1"
          paragraph
        >
          Please use these credentials to log in and complete your setup.
        </Typography>
        <Typography variant="body1">
          Best regards,
          <br />
          The TravelBank Team
        </Typography>
      </Box>
      {/* Hidden textarea for copying plain text */}
      <textarea
        style={{ position: 'absolute', left: '-9999px', top: '-9999px' }}
        readOnly
        value={templateText}
        aria-hidden="true"
        tabIndex={-1}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={() => onConfirm()}
        sx={{ mt: 2 }}
      >
        Confirm
      </Button>
    </Box>
  );
};

export default EmailPreview;
